'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('DeleteSubModuleDialogCtrl', DeleteSubModuleDialogCtrl);

  DeleteSubModuleDialogCtrl.$inject = ['$scope', 'Module', 'Project', 'errorMessageService',
    '$log', 'ProjectBusinessService', 'Labels', 'SimpleDialogFormService'];

  function DeleteSubModuleDialogCtrl ($scope, Module, ProjectAPI, errorMessageService, $log,
    ProjectBusinessService, Labels, SimpleDialogFormService) {

    $scope.open = function (ev, callback, submodule, project) {
      $scope.submodule = submodule;
      $scope.callback = callback;
      $scope.project = project;

      let options = {
        title: Labels.getLabel('deletesubmoduletitle'),
        content: Labels.getLabel('areyousuredeletesubmodule'),
        warning: Labels.getLabel('thisactioncannotbeundone'),
        ok: Labels.getLabel('delete'),
        ok_icon: 'delete',
        cancel: Labels.getLabel('cancel')
      };
      return SimpleDialogFormService.confirm(ev, options, submodule).then(deleteSubmodule);
    };

    function deleteSubmodule () {
      let deletePromise;
      if ($scope.project) {
        const module = ProjectBusinessService.findModuleBySubmoduleId($scope.project, $scope.submodule._id);
        deletePromise = ProjectAPI.deactivateSubModule({
          id: $scope.project._id,
          paramId: module._id,
          secondParamId: $scope.submodule._id,
          versionId: $scope.project.versionId,
          submoduleId: $scope.submodule._id
        });
      } else {
        deletePromise = Module.deleteSubmodule({ submoduleId: $scope.submodule._id});
      }

      return deletePromise.$promise.then(function (data) {

        errorMessageService.showSuccess(Labels.getLabel('deletedsubmodule'));
        $scope.callback(data);
      }).catch(function (err) {
        $log.error('error while deleting submodule:', err);
      });
    };
  }
})();
